import { render, staticRenderFns } from "./ProductDimensionEditorControl.vue?vue&type=template&id=403c70b6&scoped=true"
import script from "./ProductDimensionEditorControl.vue?vue&type=script&lang=js"
export * from "./ProductDimensionEditorControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403c70b6",
  null
  
)

export default component.exports